import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import Header from './header';
import LocView from './views/loc';
import TeamView from './views/team';
import SingleLocOrBuyer from './singleLocOrBuyer';
import MultiLoc from './multiLoc';
import R from 'ramda';
import { getUsersByFilter } from '../../../stores/settings/userManagement/actions';
import EditUserDialog from './editUserDialog';

class UserManagement extends Component {

  getChildContext() {
    return {
      muiTheme: this.context.muiTheme,
    };
  }

  componentWillMount() {
    this.props.getUsers(this.props.viewBy);
  }

  render() {
    const { viewBy, isSingleLoc, isBuyer } = this.props;

    return (
      <div style={{ width: '100%' }}>
        <Header/>
        {
          R.call(R.cond([
            [R.equals('location'), R.always(<LocView/>)],
            [R.equals('team'), R.always(<TeamView/>)],
            [R.equals('user'), R.always(isSingleLoc || isBuyer ? <SingleLocOrBuyer /> : <MultiLoc />)],
            [R.T, R.always(<span/>)],
          ]), viewBy)
        }
        <EditUserDialog />
      </div>
    );
  }
}

UserManagement.contextTypes = {
  muiTheme: PropTypes.object,
};

UserManagement.childContextTypes = {
  muiTheme: PropTypes.object,
};

UserManagement.propTypes = {
  viewBy: PropTypes.string,
  getUsers: PropTypes.func,
  isSingleLoc: PropTypes.bool,
  isBuyer: PropTypes.bool,
};

const mapDispatchToProps = dispatch => ({
  getUsers: viewBy => dispatch(getUsersByFilter(viewBy)),
});

const mapStateToProps = ({ userManagement, user }) => ({
  viewBy: userManagement.get('viewBy'),
  isBuyer: user.getIn(['user', 'type']) === 'Contractor',
  isSingleLoc: user.getIn(['company', 'oneOrMultiProperties']) === 'one-prop',
});

export default connect(mapStateToProps, mapDispatchToProps)(UserManagement);



// WEBPACK FOOTER //
// ./src/app/components/settings/userManagement/container.jsx